import React from "react";
import "./Footer.css";
const Footer = () => {
  const footerItems = [
    {
      id: 1,
      label: "Cookie Policy",
      href: "https://mars.com/cookies-english",
      className: "text-lg-start",
    },
    {
      id: 2,
      label: "Privacy Policy",
      href: "https://www.mars.com/privacy",
      className: "text-lg-center",
    },
    {
      id: 3,
      label: "Accessibility",
      href: "https://www.mars.com/accessibility",
      className: "text-lg-center",
    },
    {
      id: 4,
      label: "Legal Notice",
      href: "https://www.mars.com/legal",
      className: "text-lg-center",
    },
    {
      id: 5,
      label: "Terms & Conditions",
      href: "https://wellbeloved.com/pages/terms-and-conditions-2020-06-08",
      className: "text-lg-end",
    },
  ];

  return (
    <div style={{backgroundColor: "#006243"}}>
    <div className="footer-container">
      <footer className="pt-3 mt-4 pb-4 footer">
        <ul className="nav footer-items-wrapper d-flex flex-wrap list-unstyled justify-content-center justify-content-md-between mb-3 pb-lg-4">
          {footerItems.map(({ id, label, href, className }) => {
            return (
              <li
                key={id}
                className={`p-2 p-sm-3 px-md-0 py-md-3 p-lg-0 col-lg-2 nav-item footer-list flex-lg-fill ${className}`}
              >
                <a href={href} className="nav-link p-0 text-white">
                  {label}
                </a>
              </li>
            );
          })}
        </ul>
        <div class="footer-copyright text-white text-center mx-auto">
          <span>
            © 2025 Mars, Incorporated. All Rights Reserved. ®TM JAMES
            WELLBELOVED is a Trademark of Mars, Incorporated and its affiliates.
          </span>
        </div>
      </footer>
    </div>
    </div>
  );
};

export default Footer;
